export const createPluralForm = (one: string, two: string, five: string = two) => {
  const titles = [one, two, five]
  const cases = [2, 0, 1, 1, 1, 2]
  return (number: number): string => {
    return titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]]
  }
}

/**
 *
 * @param forms формы слова
 * @param number число
 * @param countFormatter
 */
export const createPluralFormWithPlaceholder = (
  forms: [string, string, (string | undefined)?] | null | undefined,
  number: number,
  countFormatter?: (value: number) => string
) => {
  const formatted = countFormatter ? countFormatter(number) : String(number)
  const pluralForm = forms && createPluralForm(...forms)(number)
  return pluralForm?.replace('{count}', formatted)
}
